// extracted by mini-css-extract-plugin
export default {"actionButtonsContianer":"_2KuAKpR3jbhF6EfAJpQe-a","switchButton":"_3w_3XDQoby22kN7iZ3z3mO","leaveButton":"r5ORXryY2PTTFGwtRY88k"};